import { useState, useEffect } from "react";
import Header from "../Header/Header1";
import "./bot.scss";
import { Button } from "@mui/material";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Grid,
  Modal,
  Switch,
  FormControlLabel,
} from "@mui/material";
import Loader from "../Loader";
import { useNavigate, useLocation } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import consts from "../../constant";
import usercalls from "../../Axios";
import toast, { Toaster } from "react-hot-toast";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "var(--common-card-bg)",
  borderRadius: "10px",
  p: 2,
};

const dealTradesModalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: {
    xs: "95vw",
    md: "88vw",
    lg: "980px",
  },
  maxHeight: "85vh",
  bgcolor: "var(--common-card-bg)",
  borderRadius: "10px",
  p: 2,
};

const DCAbottrade = () => {
  const [tradeLoading, setTradeLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const botId = location.state?.id || location.state?.bot_id || null;
  const path = usercalls();

  const [botDetails, setBotDetails] = useState({});
  const [botEnabled, setBotEnabled] = useState(false);
  const [toggleLoading, setToggleLoading] = useState(false);
  const [closeLoading, setCloseLoading] = useState(false);
  const [cancelLoading, setCancelLoading] = useState(false);
  const [triggerLoading, setTriggerLoading] = useState(false);
  const [openCloseModal, setOpenCloseModal] = useState(false);
  const [openCancelModal, setOpenCancelModal] = useState(false);
  const [botStats, setBotStats] = useState({});
  const [statsLoading, setStatsLoading] = useState(false);
  const [dealTrades, setDealTrades] = useState([]);
  const [dealTradesLoading, setDealTradesLoading] = useState(false);
  const [openDealTradesModal, setOpenDealTradesModal] = useState(false);
  const [selectedDealId, setSelectedDealId] = useState(null);
  const [dealActionLoading, setDealActionLoading] = useState({
    id: null,
    type: null,
  });
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [activeDeals, setActiveDeals] = useState([]);

  const formatFixed = (value, digits = 5) => {
    const numberValue = Number(value);
    return Number.isFinite(numberValue)
      ? parseFloat(numberValue.toFixed(digits))
      : "0.00";
  };

  const formatDealDate = (dateValue) => {
    if (!dateValue) return "-";
    const date = new Date(dateValue);
    if (Number.isNaN(date.getTime())) return String(dateValue);
    return date.toLocaleString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    });
  };

  const getDealStatusStyle = (status) => {
    const normalizedStatus = String(status || "").toLowerCase();
    if (
      normalizedStatus.includes("filled") ||
      normalizedStatus.includes("done")
    ) {
      return { color: "#00C853", borderColor: "rgba(0, 200, 83, 0.35)" };
    }
    if (
      normalizedStatus.includes("cancel") ||
      normalizedStatus.includes("fail")
    ) {
      return { color: "#FF5252", borderColor: "rgba(255, 82, 82, 0.35)" };
    }
    return { color: "#F8D821", borderColor: "rgba(248, 216, 33, 0.35)" };
  };

  const getStartOrderTypeLabel = (startOrderType) => {
    if (!startOrderType) return "-";
    if (startOrderType === "signal") return "Trading View Signal";

    return String(startOrderType)
      .split("_")
      .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
      .join(" ");
  };

  const getProfitCurrencyLabel = (profitCurrency) => {
    if (profitCurrency === "quote_currency") return "Quote Currency";
    if (profitCurrency === "base_currency") return "Base Currency";
    return "-";
  };

  const formatPairs = (pairsValue) => {
    if (Array.isArray(pairsValue) && pairsValue.length > 0) {
      return pairsValue
        .map((pair) => String(pair).replace(/_/g, "/"))
        .join(", ");
    }

    if (typeof pairsValue === "string" && pairsValue) {
      return pairsValue.replace(/_/g, "/");
    }

    return "-";
  };

  const hasManualStrategy =
    Array.isArray(botDetails?.strategy_list) &&
    botDetails.strategy_list.some((strategyItem) => {
      const strategyName =
        typeof strategyItem === "string"
          ? strategyItem
          : strategyItem?.strategy;
      return String(strategyName || "").toLowerCase() === "manual";
    });

  const canTriggerManualDeal =
    botDetails?.start_order_type === "manual" || hasManualStrategy;

  const getDeals = async () => {
    if (!botId) {
      setActiveDeals([]);
      return;
    }

    try {
      setTradeLoading(true);
      const url = `${consts.BackendUrl}/bots/get-deals`;
      const payload = { bot_id: botId };
      const response = await path.postCall({ url, payload });
      const result = await response.json();

      if (result?.success) {
        setActiveDeals(Array.isArray(result.result) ? result.result : []);
      } else {
        setActiveDeals([]);
      }
    } catch (err) {
      setActiveDeals([]);
    } finally {
      setTradeLoading(false);
    }
  };

  useEffect(() => {
    if (!botId) return;

    getDeals();
    getBotDetails();
    getBotStats();
  }, [botId]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const activePaginated = activeDeals.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage,
  );

  const getBotDetails = async () => {
    if (!botId) {
      setBotDetails({});
      setBotEnabled(false);
      return;
    }

    try {
      const url = `${consts.BackendUrl}/bots/get-bot`;
      const payload = { id: botId };

      const response = await path.postCall({ url, payload });
      const result = await response.json();

      if (result?.success || result?.id) {
        const botData = result?.success ? result?.result : result;

        if (!botData || typeof botData !== "object") {
          setBotDetails({});
          setBotEnabled(false);
          return;
        }

        setBotDetails(botData);
        setBotEnabled(Boolean(botData?.is_enabled));
      } else {
        setBotDetails({});
        setBotEnabled(false);
      }
    } catch (err) {
      setBotDetails({});
      setBotEnabled(false);
    }
  };

  const getBotStats = async () => {
    if (!botId) {
      setBotStats({});
      return;
    }

    try {
      setStatsLoading(true);
      const url = `${consts.BackendUrl}/bots/get-bot-stats`;
      const payload = { bot_id: botId };

      const response = await path.postCall({ url, payload });
      const result = await response.json();

      if (result?.success) {
        setBotStats(result.result || {});
      } else {
        setBotStats({});
      }
    } catch (err) {
      setBotStats({});
    } finally {
      setStatsLoading(false);
    }
  };

  const handleToggleBotStatus = async (isEnabled) => {
    if (!botId) {
      toast.error("Bot ID is required");
      return;
    }

    const previousStatus = botEnabled;
    setBotEnabled(isEnabled);

    try {
      setToggleLoading(true);
      const url = `${consts.BackendUrl}/bots/enable-bot`;
      const payload = {
        id: botId,
        type: isEnabled ? "enable" : "disable",
      };

      const response = await path.postCall({ url, payload });
      const result = await response.json();

      if (result?.success) {
        toast.success(
          result?.message ||
            `Bot ${isEnabled ? "enabled" : "disabled"} successfully`,
        );
        await getBotDetails();
        await getBotStats();
      } else {
        setBotEnabled(previousStatus);
        toast.error(result?.message || "Failed to toggle bot status");
      }
    } catch (err) {
      setBotEnabled(previousStatus);
      toast.error(err?.message || "Cannot toggle bot status");
    } finally {
      setToggleLoading(false);
    }
  };

  const handleSwitchChange = (e) => {
    handleToggleBotStatus(e.target.checked);
  };

  const getDealTrades = async (dealId) => {
    if (!dealId) return;

    try {
      setDealTradesLoading(true);
      const url = `${consts.BackendUrl}/bots/get-deal-trades`;
      const payload = { deal_id: dealId };

      const response = await path.postCall({ url, payload });
      const result = await response.json();

      if (result?.success) {
        setDealTrades(Array.isArray(result.result) ? result.result : []);
      } else {
        setDealTrades([]);
        toast.error(result?.message || "Failed to fetch deal trades");
      }
    } catch (err) {
      setDealTrades([]);
      toast.error(err?.message || "Cannot fetch deal trades");
    } finally {
      setDealTradesLoading(false);
    }
  };

  const handleViewDealTrades = (dealId) => {
    setSelectedDealId(dealId);
    setOpenDealTradesModal(true);
    getDealTrades(dealId);
  };

  const handleCancelDeal = async (dealId) => {
    if (!dealId) return;

    try {
      setDealActionLoading({ id: dealId, type: "cancel" });
      const url = `${consts.BackendUrl}/bots/cancel-deal`;
      const payload = { deal_id: dealId };

      const response = await path.postCall({ url, payload });
      const result = await response.json();

      if (result?.success) {
        toast.success(result?.message || "Deal cancelled successfully");
        await getDeals();
      } else {
        toast.error(result?.message || "Failed to cancel deal");
      }
    } catch (err) {
      toast.error(err?.message || "Cannot cancel deal");
    } finally {
      setDealActionLoading({ id: null, type: null });
    }
  };

  const handleCloseDealAtMarket = async (dealId) => {
    if (!dealId) return;

    try {
      setDealActionLoading({ id: dealId, type: "close" });
      const url = `${consts.BackendUrl}/bots/close-deal-at-market`;
      const payload = { deal_id: dealId };

      const response = await path.postCall({ url, payload });
      const result = await response.json();

      if (result?.success) {
        toast.success(result?.message || "Deal closed at market successfully");
        await getDeals();
      } else {
        toast.error(result?.message || "Failed to close deal");
      }
    } catch (err) {
      toast.error(err?.message || "Cannot close deal");
    } finally {
      setDealActionLoading({ id: null, type: null });
    }
  };

  const handleCloseBot = async () => {
    try {
      setCloseLoading(true);
      const url = `${consts.BackendUrl}/bots/close-bot-at-market`;
      const payload = { id: botId };

      const response = await path.postCall({ url, payload });
      const result = await response.json();

      if (result?.success) {
        toast.success(
          result?.message || "All deals closed at market price successfully",
        );
        setOpenCloseModal(false);
        // Refresh bot details and stats
        await getBotDetails();
        await getBotStats();
      } else {
        toast.error(result?.message || "Failed to close bot deals");
      }
    } catch (err) {
      toast.error(err?.message || "Cannot close bot deals");
    } finally {
      setCloseLoading(false);
    }
  };

  const handleCancelBot = async () => {
    try {
      setCancelLoading(true);
      const url = `${consts.BackendUrl}/bots/cancel-bot`;
      const payload = { id: botId };

      const response = await path.postCall({ url, payload });
      const result = await response.json();

      if (result?.success) {
        toast.success(result?.message || "All deals cancelled successfully");
        setOpenCancelModal(false);
        // Refresh bot details and stats
        await getBotDetails();
        await getBotStats();
      } else {
        toast.error(result?.message || "Failed to cancel bot");
      }
    } catch (err) {
      toast.error(err?.message || "Cannot cancel bot");
    } finally {
      setCancelLoading(false);
    }
  };

  const handleTriggerManualBot = async () => {
    if (!botId) {
      toast.error("Bot ID is required");
      return;
    }

    try {
      setTriggerLoading(true);
      const url = `${consts.BackendUrl}/bots/trigger-manual-dca-bot`;
      const payload = { id: botId };

      const response = await path.postCall({ url, payload });
      const result = await response.json();

      if (result?.success) {
        toast.success(result?.message || "Bot triggered successfully");
        // Refresh bot details and deals
        await getBotDetails();
        await getBotStats();
        await getDeals();
      } else {
        toast.error(result?.message || "Failed to trigger bot");
      }
    } catch (err) {
      toast.error(err?.message || "Cannot trigger bot");
    } finally {
      setTriggerLoading(false);
    }
  };

  return (
    <div className="market-full page_align" style={{ minHeight: "100vh" }}>
      <Header />
      <Toaster />

      <Grid container className="mb-20">
        <Grid item xs={12}>
          <Button startIcon={<ArrowBackIcon />} onClick={() => navigate(-1)}>
            Back
          </Button>
        </Grid>
      </Grid>

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <div className="bot_container contain-width mb-20">
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6} md={4}>
                <div className="display-2">
                  <h4>Bot Name</h4>
                  <div>{botDetails?.name || "-"}</div>
                </div>
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <div className="display-2">
                  <h4>Pairs</h4>
                  <div>{formatPairs(botDetails?.pairs)}</div>
                </div>
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <div className="display-2">
                  <h4>Volume</h4>
                  <div>{botDetails?.base_order_volume || "-"}</div>
                </div>
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <div className="display-2">
                  <h4>Take Profit Type</h4>
                  <div>
                    {botDetails?.take_profit_type === "total"
                      ? "Total"
                      : botDetails?.take_profit_type === "base"
                        ? "Base"
                        : "-"}
                  </div>
                </div>
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <div className="display-2">
                  <h4>Take Profit (%)</h4>
                  <div>{botDetails?.take_profit || "-"}</div>
                </div>
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <div className="display-2">
                  <h4>Risk Percentage</h4>
                  <div>{botDetails?.risk_reduction_percentage || "-"}</div>
                </div>
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <div className="display-2">
                  <h4>Safety Order Percentage</h4>
                  <div>{botDetails?.safety_order_step_percentage || "-"}</div>
                </div>
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <div className="display-2">
                  <h4>Safety Order Volume</h4>
                  <div>{botDetails?.safety_order_volume || "-"}</div>
                </div>
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <div className="display-2">
                  <h4>Max Safety Order</h4>
                  <div>{botDetails?.max_safety_orders || "-"}</div>
                </div>
              </Grid>

              {/* <Grid item xs={12} sm={6} md={4}>
                  <div className="display-2">
                    <h4>Leverage Type</h4>
                    <div>
                      {botDetails?.leverage_type === "not_specified"
                        ? "Not Specified"
                        : botDetails?.leverage_type || "-"}
                    </div>
                  </div>
                </Grid> */}

              {/* <Grid item xs={12} sm={6} md={4}>
                  <div className="display-2">
                    <h4>Min Price</h4>
                    <div>{botDetails?.min_price || "-"}</div>
                  </div>
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <div className="display-2">
                    <h4>Max Price</h4>
                    <div>{botDetails?.max_price || "-"}</div>
                  </div>
                </Grid> */}

              <Grid item xs={12} sm={6} md={4}>
                <div className="display-2">
                  <h4>Profit Currency</h4>
                  <div>
                    {getProfitCurrencyLabel(botDetails?.profit_currency)}
                  </div>
                </div>
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <div className="display-2">
                  <h4>Start Order Type</h4>
                  <div>
                    {getStartOrderTypeLabel(botDetails?.start_order_type)}
                  </div>
                </div>
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <div className="display-2">
                  <h4>Bot ID</h4>
                  <div
                    style={{
                      wordBreak: "break-all",
                      fontFamily: "monospace",
                      fontSize: "14px",
                    }}
                  >
                    {botDetails?.id || botDetails?.bot_id || "-"}
                  </div>
                </div>
              </Grid>

              {(botDetails?.start_order_type === "signal" ||
                (Array.isArray(botDetails?.strategy_list) &&
                  botDetails.strategy_list.some(
                    (s) => s.strategy === "tv_custom_signal",
                  ))) && (
                <>
                  <Grid item xs={12}>
                    <div className="display-2">
                      <h4>Webhook URL for TradingView</h4>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "flex-start",
                          gap: "10px",
                        }}
                      >
                        <div>
                          {`${consts.BackendUrl}/bots/trigger-trading-view`}
                        </div>

                        <ContentCopyIcon
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            const webhookUrl = `${consts.BackendUrl}/bots/trigger-trading-view`;
                            navigator.clipboard.writeText(webhookUrl);
                            toast.success("Webhook URL copied to clipboard!");
                          }}
                        />
                      </div>
                    </div>
                  </Grid>

                  <Grid item xs={12}>
                    <div className="display-2">
                      <h4>TradingView Alert Message (JSON Payload)</h4>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "flex-start",
                          gap: "10px",
                        }}
                      >
                        <div
                          style={{
                            wordBreak: "break-all",
                            fontFamily: "monospace",
                            fontSize: "12px",
                            padding: "10px",
                            borderRadius: "4px",
                            whiteSpace: "pre-wrap",
                            flex: 1,
                          }}
                        >
                          {JSON.stringify(
                            {
                              account_id: botDetails?.account_id || 0,
                              bot_id: botDetails?.id || botDetails?.bot_id || 0,
                            },
                            null,
                            2,
                          )}
                        </div>

                        <ContentCopyIcon
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            const payload = JSON.stringify(
                              {
                                account_id: botDetails?.account_id || 0,
                                bot_id:
                                  botDetails?.id || botDetails?.bot_id || 0,
                              },
                              null,
                              2,
                            );
                            navigator.clipboard.writeText(payload);
                            toast.success("Payload copied to clipboard!");
                          }}
                        />
                      </div>
                    </div>
                  </Grid>
                </>
              )}
              <Grid item xs={12}>
                <div
                  className="display-4"
                  style={{ gap: "10px", marginTop: "10px", flexWrap: "wrap" }}
                >
                  <div className="bot_comman_btn">
                    <FormControlLabel
                      control={
                        <Switch
                          checked={botEnabled}
                          onChange={handleSwitchChange}
                          color="primary"
                          disabled={toggleLoading}
                        />
                      }
                      label={botEnabled ? "Enabled" : "Disabled"}
                    />
                  </div>

                  {canTriggerManualDeal && (
                    <div className="bot_comman_btn">
                      <Button
                        onClick={handleTriggerManualBot}
                        disabled={
                          triggerLoading || !botDetails?.id || !botEnabled
                        }
                        variant="contained"
                        color="success"
                      >
                        {triggerLoading ? "Triggering..." : "Start New Deal"}
                      </Button>
                    </div>
                  )}

                  {botDetails?.active_deals_count > 0 && (
                    <div className="bot_comman_btn">
                      <Button
                        onClick={() => setOpenCloseModal(true)}
                        disabled={closeLoading || !botDetails?.id}
                      >
                        Close at Market Price
                      </Button>
                    </div>
                  )}

                  {/* {botDetails?.active_deals_count > 0 && (
                    <div className="bot_comman_btn">
                      <Button
                        onClick={() => setOpenCancelModal(true)}
                        disabled={cancelLoading || !botDetails?.id}
                      >
                        Cancel All Deals
                      </Button>
                    </div>
                  )} */}
                </div>
              </Grid>
            </Grid>
          </div>
        </Grid>
      </Grid>

      <Grid container spacing={2} className="mt-20">
        {/* <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <div className="flexend">
                        <div className='bot_comman_btn' >
                            <Button
                            >
                               Enable
                            </Button>
                        </div>
                        <div className='bot_comman_btn' >
                            <Button
                            >
                                Disable
                            </Button>
                        </div>
                        <div className='bot_comman_btn' >
                            <Button
                            >
                                Close Bot
                            </Button>
                        </div>
                        <div className='bot_comman_btn' >
                            <Button
                            >
                                Cancel Bot
                            </Button>
                        </div>
                    </div>
                </Grid> */}
        <Grid
          item
          xs={12}
          sm={12}
          md={6}
          lg={3}
          xl={3}
          className="grid-bot-full mt-20"
        >
          <div className="bot_dash flex-1 just-center p-2 mt-20">
            <div>Overall USDT Profit</div>
            <div>
              {statsLoading
                ? "Loading..."
                : `${formatFixed(botStats?.profits_in_usd?.overall_usd_profit)} USDT`}
            </div>
          </div>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={6}
          lg={3}
          xl={3}
          className="grid-bot-full"
        >
          <div className="bot_dash flex-1 just-center p-2 mt-20">
            <div>Today USDT Profit</div>
            <div>
              {statsLoading
                ? "Loading..."
                : `${formatFixed(botStats?.profits_in_usd?.today_usd_profit)} USDT`}
            </div>
          </div>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={6}
          lg={3}
          xl={3}
          className="grid-bot-full"
        >
          <div className="bot_dash flex-1 just-center p-2 mt-20">
            <div>Active Deals USDT Profit</div>
            <div>
              {statsLoading
                ? "Loading..."
                : `${formatFixed(botStats?.profits_in_usd?.active_deals_usd_profit)} USDT`}
            </div>
          </div>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={6}
          lg={3}
          xl={3}
          className="grid-bot-full"
        >
          <div className="bot_dash flex-1 just-center p-2 mt-20">
            <div>Funds Locked</div>
            <div>
              {statsLoading
                ? "Loading..."
                : `${formatFixed(botStats?.profits_in_usd?.funds_locked_in_active_deals)} USDT`}
            </div>
          </div>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <div className="mt-20">
            <div className="custom_table box_bdr mt-20">
              <div className="h_flx">
                <h3>Active Trade</h3>
              </div>

              <TableContainer sx={{ marginBottom: "10px" }}>
                <Table sx={{ minWidth: 650 }}>
                  <TableHead>
                    <TableRow>
                      <TableCell>Created At</TableCell>
                      <TableCell>Pair</TableCell>
                      <TableCell>Status</TableCell>
                      <TableCell>Current Price</TableCell>
                      <TableCell>Bought Avg Price</TableCell>
                      <TableCell>Take Profit Price</TableCell>
                      <TableCell>Actual USD Profit</TableCell>
                      <TableCell>Deal ID</TableCell>
                      <TableCell style={{ textAlign: "center" }}>
                        Actions
                      </TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {tradeLoading ? (
                      <TableRow>
                        <TableCell colSpan={9}>
                          <div className="inline-loader">
                            <Loader />
                          </div>
                        </TableCell>
                      </TableRow>
                    ) : activePaginated?.length > 0 ? (
                      activePaginated.map((row, i) => (
                        <TableRow key={i} className="tr_row">
                          <TableCell>
                            {row.created_at
                              ? new Date(row.created_at).toLocaleString()
                              : "-"}
                          </TableCell>
                          <TableCell>{formatPairs(row.pair)}</TableCell>
                          <TableCell>
                            {row.localized_status || row.status || "-"}
                          </TableCell>
                          <TableCell>{row.current_price || "-"}</TableCell>
                          <TableCell>
                            {row.bought_average_price || "-"}
                          </TableCell>
                          <TableCell>{row.take_profit_price || "-"}</TableCell>
                          <TableCell>{row.actual_usd_profit || "-"}</TableCell>
                          <TableCell>{row.id || "-"}</TableCell>
                          <TableCell
                            style={{
                              display: "flex",
                              gap: "10px",
                              justifyContent: "center",
                            }}
                          >
                            <div className="bot_comman_btn ">
                              <Button
                                size="small"
                                className="p-5"
                                onClick={() => handleViewDealTrades(row.id)}
                                disabled={
                                  dealActionLoading.id === row.id ||
                                  tradeLoading
                                }
                              >
                                View
                              </Button>
                            </div>
                            <div className="bot_comman_btn">
                              <Button
                                size="small"
                                className="p-5"
                                onClick={() => handleCancelDeal(row.id)}
                                disabled={!row["cancellable?"]}
                              >
                                {dealActionLoading.id === row.id &&
                                dealActionLoading.type === "cancel"
                                  ? "Cancelling..."
                                  : "Cancel"}
                              </Button>
                            </div>
                            <div className="bot_comman_btn">
                              <Button
                                size="small"
                                className="p-5"
                                onClick={() => handleCloseDealAtMarket(row.id)}
                                disabled={!row["panic_sellable?"]}
                              >
                                {dealActionLoading.id === row.id &&
                                dealActionLoading.type === "close"
                                  ? "Closing..."
                                  : "Close Market"}
                              </Button>
                            </div>
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={9} align="center">
                          No Active Trades
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
                <TablePagination
                  component="div"
                  count={activeDeals.length}
                  page={page}
                  onPageChange={handleChangePage}
                  rowsPerPageOptions={[10]}
                  rowsPerPage={rowsPerPage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </TableContainer>
            </div>
          </div>
        </Grid>
      </Grid>

      {/* Close Bot Confirmation Modal */}
      <Modal
        open={openCloseModal}
        onClose={() => !closeLoading && setOpenCloseModal(false)}
      >
        <Box sx={style}>
          <div className="p-20">
            <h3 className="mb-20">Close Bot at Market</h3>
            <p>
              Are you sure you want to close all deals at market price? This
              will disable the bot.
            </p>
          </div>

          <div className="display-2" style={{ gap: "10px" }}>
            <div className="bot_comman_btn display-3 mt-20">
              <Button
                variant="contained"
                onClick={() => setOpenCloseModal(false)}
                disabled={closeLoading}
              >
                Cancel
              </Button>
            </div>

            <div className="bot_comman_btn display-3 mt-20">
              <Button
                variant="contained"
                color="error"
                onClick={handleCloseBot}
                disabled={closeLoading}
              >
                {closeLoading ? "Closing..." : "Close Bot"}
              </Button>
            </div>
          </div>
        </Box>
      </Modal>

      {/* Cancel Bot Confirmation Modal */}
      <Modal
        open={openCancelModal}
        onClose={() => !cancelLoading && setOpenCancelModal(false)}
      >
        <Box sx={style}>
          <div className="p-20">
            <h3 className="mb-20">Cancel Bot</h3>
            <p>
              Are you sure you want to cancel all deals? This will disable the
              bot.
            </p>
          </div>

          <div className="display-2" style={{ gap: "10px" }}>
            <div className="bot_comman_btn display-3 mt-20">
              <Button
                variant="contained"
                onClick={() => setOpenCancelModal(false)}
                disabled={cancelLoading}
              >
                Cancel
              </Button>
            </div>

            <div className="bot_comman_btn display-3 mt-20">
              <Button
                variant="contained"
                color="error"
                onClick={handleCancelBot}
                disabled={cancelLoading}
              >
                {cancelLoading ? "Cancelling..." : "Cancel Bot"}
              </Button>
            </div>
          </div>
        </Box>
      </Modal>

      {/* Deal Trades Modal */}
      <Modal
        open={openDealTradesModal}
        onClose={() => setOpenDealTradesModal(false)}
      >
        <Box sx={dealTradesModalStyle}>
          <div
            className="display-2 p-20"
            style={{ justifyContent: "space-between" }}
          >
            <div className="coins">Deal Trades</div>
            <div style={{ opacity: 0.75, fontSize: "12px" }}>
              Deal ID: {selectedDealId || "-"}
            </div>
          </div>

          <div style={{ maxHeight: "60vh", overflow: "auto" }}>
            <TableContainer
              sx={{
                maxHeight: "56vh",
                overflow: "auto",
                borderRadius: "10px",
                border: "1px solid rgba(255,255,255,0.18)",
                backgroundColor: "rgba(8,12,18,0.92)",
                boxShadow: "inset 0 0 0 1px rgba(255,255,255,0.08)",
                color: "#FFFFFF",
              }}
            >
              <Table
                size="small"
                stickyHeader
                sx={{
                  "& .MuiTableCell-root": {
                    color: "#FFFFFF",
                    borderColor: "rgba(255,255,255,0.12)",
                    whiteSpace: "nowrap",
                    fontSize: "13px",
                  },
                  "& .MuiTableHead-root .MuiTableCell-root": {
                    backgroundColor: "#10151C",
                    fontWeight: 700,
                  },
                  "& .MuiTableBody-root .MuiTableRow-root": {
                    backgroundColor: "rgba(10,14,20,0.88)",
                  },
                  "& .MuiTableBody-root .MuiTableRow-root:hover": {
                    backgroundColor: "rgba(18,24,32,0.95)",
                  },
                }}
              >
                <TableHead>
                  <TableRow>
                    <TableCell>Order ID</TableCell>
                    <TableCell>Order Type</TableCell>
                    <TableCell>Deal Order Type</TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell>Created At</TableCell>
                    <TableCell align="right">Quantity</TableCell>
                    <TableCell align="right">Rate</TableCell>
                    <TableCell align="right">Total</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {dealTradesLoading ? (
                    <TableRow>
                      <TableCell colSpan={8}>
                        <div className="inline-loader">
                          <Loader />
                        </div>
                      </TableCell>
                    </TableRow>
                  ) : dealTrades?.length > 0 ? (
                    dealTrades.map((trade, index) => (
                      <TableRow
                        key={trade.order_id || index}
                        className="tr_row"
                      >
                        <TableCell>{trade.order_id || "-"}</TableCell>
                        <TableCell>{trade.order_type || "-"}</TableCell>
                        <TableCell>{trade.deal_order_type || "-"}</TableCell>
                        <TableCell>
                          <span
                            style={{
                              ...getDealStatusStyle(trade.status_string),
                            }}
                          >
                            {trade.status_string || "-"}
                          </span>
                        </TableCell>
                        <TableCell>
                          {formatDealDate(trade.created_at)}
                        </TableCell>
                        <TableCell align="right">
                          {trade.quantity || "-"}
                        </TableCell>
                        <TableCell align="right">{trade.rate || "-"}</TableCell>
                        <TableCell align="right">
                          {trade.total || "-"}
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={8} align="center">
                        No Trades Found
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </div>

          <div className="bot_comman_btn display-3 mt-20">
            <Button
              variant="contained"
              onClick={() => setOpenDealTradesModal(false)}
            >
              Close
            </Button>
          </div>
        </Box>
      </Modal>
    </div>
  );
};

export default DCAbottrade;
